'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionsModel', function TransactionsModel(ModelFactory,
                                                           TransactionRepository) {

    var MAX_TRANSACTIONS = 10000;
    
    var transactionsModel = ModelFactory.create('TransactionsModel', [
      'transactions',
      'loading',
      'transactionCount',
      'maxTransactions',
      'transactionCurrency'
    ]);
    transactionsModel.transactions([]);
    transactionsModel.transactionCurrency([]);
    transactionsModel.loading(false);
    transactionsModel.transactionCount(0);
    transactionsModel.maxTransactions(MAX_TRANSACTIONS);

    transactionsModel.refreshTransactions = function (transactionsIds) {
      var oldTransactions = transactionsModel.transactions();
      return TransactionRepository.getTransactions(transactionsIds)
        .then(function (updatedTransactions) {
          transactionsModel.transactions(_.uniqBy(updatedTransactions.concat(oldTransactions), 'id'));
          return updatedTransactions;
        });
    };

    transactionsModel.updateAllocations = function (transaction, newAllocations) {
      transactionsModel.refreshTransactions([transaction.id]).then(function () {
        var found = _.find(transactionsModel.transactions(), {id: transaction.id});

        if (found !== undefined) {
          angular.copy(newAllocations, found.allocations);
          angular.forEach(found.allocations, pruneEmbedded);
        }
      });
    };

    return transactionsModel;

    function pruneEmbedded(object) {
      _.unset(object, '_embedded');
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/TransactionsModel.js
// module id = 595
// module chunks = 0